module.exports = __webpack_public_path__ + "img/koupelna.c2609483.jpg";